import { BaseException } from "@/exceptions/base-exception.exception.ts"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights.ts"

export class WorkPeriodExceedsMaxDurationException extends BaseException {
  exceptionId = "WORK_PERIOD_EXCEEDS_MAX_DURATION"
  title = "Dienst overschrijdt maximale duur"
  weight = ExceptionWeights.ERROR

  private readonly maxDurationMinutes: number
  private readonly actualDurationMinutes: number

  constructor(maxDurationMinutes: number, actualDurationMinutes: number) {
    super()
    this.maxDurationMinutes = maxDurationMinutes
    this.actualDurationMinutes = actualDurationMinutes
  }

  public getMessage(): string {
    const actualDurationHoursPart = Math.floor(this.actualDurationMinutes / 60)
    const actualDurationMinutesPart = this.actualDurationMinutes % 60
    return `De dienst overschrijdt de maximale duur van ${this.maxDurationMinutes / 60} uur. Jouw dienst duurt ${actualDurationHoursPart} uur en ${actualDurationMinutesPart} minuten.`
  }
}
